import Swiper from 'swiper';
import { $Q } from '../utils/query-selector';

/**
 * Add or remove class in two nodes
 * @param {node} trigger1
 * @param {node} trigger2
 * @author Daniel Santos
 */

function toggleCssClass(trigger1, trigger2) {
  if (!trigger1.classList.contains('active')) {
    trigger1.classList.add('active')
  }

  if (trigger2.classList.contains('active')) {
    trigger2.classList.remove('active')
  }
}

/**
 * It toggles button classes
 * @param {HTMLElement} trigger1 : It is the btn 1
 * @param {HTMLElement} trigger2 : It is the btn 2
 */
function toggleBtns(trigger1, trigger2) {
  if(
    !trigger1.classList.contains('tabs-grid__navigation-btn') ||
    !trigger2.classList.contains('tabs-grid__navigation-btn')) {
    return;
  }

  trigger1.classList.toggle('btn-1')
  trigger1.classList.toggle('btn-2')
  trigger2.classList.toggle('btn-1')
  trigger2.classList.toggle('btn-2')
}

/**
 * Toggle to product cards sliders in collection carousel
 * @param {String} queryContainer : It is the query for the selector
 * @param {String} queryBtn1 : It is the query for btn1
 * @param {String} queryBtn2 : It is the query for btn2
 * @author Daniel Santos
 */
export function carouselProductsToggle(queryContainer, queryBtn1, queryBtn2) {
  const toggle = new Swiper(queryContainer)
  const btn1 = $Q(queryBtn1)
  const btn2 = $Q(queryBtn2)

  toggle.on('slideChange', (e) => {
    if (e.activeIndex === 1) {
      toggleCssClass(btn2, btn1)
      toggleBtns(btn1, btn2)
    } else {
      toggleCssClass(btn1, btn2)
      toggleBtns(btn1, btn2)
    }
  })

  if (btn1 && btn2) {
    btn1.addEventListener('click', () => {
      toggle.slideTo(0)
      toggleCssClass(btn1, btn2)
      toggleBtns(btn1, btn2)
    })

    btn2.addEventListener('click', () => {
      toggle.slideTo(1)
      toggleCssClass(btn2, btn1)
      toggleBtns(btn1, btn2)
    })
  }
}
